import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { FormsModule } from "@angular/forms";
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from './components/components.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AuthModule, LogLevel, OidcConfigService} from 'angular-auth-oidc-client';
import { EditorModule } from '@progress/kendo-angular-editor';


import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');

}

export function configureAuth(oidcConfigService: OidcConfigService) {
  return () =>
    oidcConfigService.withConfig({
      clientId: '7e56720b-7348-483d-bda3-892f3aa6f311',
      stsServer: 'https://mac.medis.land',
      responseType: 'code',
      redirectUrl: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      scope: 'openid profile apiService_f89dbcdd-fcfb-400b-8b0c-c528718df5e5 offline_access',
      logLevel: LogLevel.Debug,
    });
}

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    AuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot(),
    EditorModule,
    FontAwesomeModule
  ],
  declarations: [AppComponent, AdminLayoutComponent],
  providers: [
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
